<template>
    <div class="integral-log app-region blank-t-v blank-l-h blank-r-h">
        <a-row type="flex" align="bottom" :gutter="[16, 16]" class="mg-normal">
            <a-col :span="24" :xl="8">
                <a-row :gutter="[8, 8]">
                    <a-col>
                        <p>积分事件</p>
                    </a-col>
                    <a-col>
                        <a-input placeholder="请输入积分事件" v-model="table.search.name"></a-input>
                    </a-col>
                </a-row>
            </a-col>
            <a-col :span="24" :xl="8">
                <a-row :gutter="[8, 8]">
                    <a-col>
                        <p>积分时间</p>
                    </a-col>
                    <a-col>
                        <a-range-picker v-model="table.search.date" show-time class="app-block"
                            valueFormat="YYYY-MM-DD HH:mm:ss"></a-range-picker>
                    </a-col>
                </a-row>
            </a-col>
            <a-col :span="24" :xl="8">
                <a-row :gutter="[8, 8]">
                    <a-col>
                        <p>积分类型</p>
                    </a-col>
                    <a-col>
                        <a-select v-model="table.search.type" class="app-block" placeholder="请选择积分类型">
                            <a-select-option :value="1">增加</a-select-option>
                            <a-select-option :value="2">减少</a-select-option>
                        </a-select>
                    </a-col>
                </a-row>
            </a-col>
            <a-col :span="24" :xl="8">
                <a-space>
                    <a-button type="primary" @click="searchTable">查询</a-button>
                    <a-button @click="resetSearchTable">重置</a-button>
                </a-space>
            </a-col>
        </a-row>
        <a-row class="mg-normal" v-if="id">
            <a-col>
                <a-space>
                    <a-button type="primary" @click="changePoints()">调整积分</a-button>
                </a-space>
            </a-col>
        </a-row>
        <a-table class="mg-normal" :loading="table.loading" :columns="table.columns" :data-source="table.data" rowKey="id"
            :pagination="table.page" @change="handlePageChange">
            <template slot="score" slot-scope="text, data">
                <a-tag color="red" v-if="data.type === 1">+{{ data.score }}</a-tag>
                <a-tag color="green" v-else>-{{ data.score }}</a-tag>
            </template>
        </a-table>
        <a-modal :title="modal.title" :confirm-loading="modal.loading" v-model="modal.show" @ok="confirmModal"
            destroy-on-close>
            <a-form-model ref="form" :model="form" layout="vertical" :rules="rules">
                <a-form-model-item label="调整类型" prop="type">
                    <a-radio-group v-model="form.type">
                        <a-radio :value="1">增加</a-radio>
                        <a-radio :value="2">减少</a-radio>
                    </a-radio-group>
                </a-form-model-item>
                <a-form-model-item label="调整额度" prop="number">
                    <a-input-number class="app-block" v-model="form.number" placeholder="请输入额度" :min="0"></a-input-number>
                </a-form-model-item>
                <a-form-model-item label="备注" prop="note">
                    <a-textarea v-model="form.note" placeholder="请输入备注"></a-textarea>
                </a-form-model-item>
            </a-form-model>
        </a-modal>
    </div>
</template>
  
<script>
import IntegralLogService from '@/io/integral_log.js';

export default {
    name: 'IntegralLog',
    data() {
        let self = this;
        return {
            id: this.$route.params.id,
            table: {
                loading: false,
                search: {
                    name: null,
                    date: [],
                    type: []
                },
                page: {
                    total: 0,
                    current: 1,
                    pageSize: 10,
                    showQuickJumper: true,
                    showSizeChanger: true,
                    showTotal() {
                        return `共${self.table.page.total}条`;
                    }
                },
                data: [],
                columns: [
                    {
                        title: '账号',
                        dataIndex: 'user_info.name'
                    },
                    {
                        title: '积分事件',
                        dataIndex: 'info'
                    },
                    {
                        title: '积分',
                        scopedSlots: { customRender: 'score' }
                    },
                    {
                        title: '操作来源',
                        dataIndex: 'origin'
                    },
                    {
                        title: '事件时间',
                        dataIndex: 'created_at'
                    },
                    {
                        title: '备注',
                        dataIndex: 'remark'
                    }
                ]
            },
            form: {
                type: null,
                number: 0,
                note: null
            },
            rules: {
                type: [
                    {
                        required: true,
                        message: '请选择类型'
                    }
                ],
                number: [
                    {
                        required: true,
                        message: '请输入额度'
                    }
                ]
            },
            modal: {
                id: null,
                title: '调整积分',
                show: false,
                loading: false
            }
        }
    },
    watch: {
        id: {
            handler(newValue, oldValue) {
                if (newValue) {
                    this.initData();
                }
            },
            immediate: true
        }
    },
    activated() {
        this.initData();
    },
    methods: {
        changePoints() {
            this.modal.show = true;
        },
        confirmModal() {
            this.$beforeFormSubmit(this.$refs.form, () => {
                this.modal.loading = true;
                IntegralLogService.change(
                    this.id,
                    this.form.type,
                    this.form.number,
                    this.form.note
                ).then(res => {
                    this.$afterFormSubmit('编辑成功', () => {
                        this.initData();
                    });
                }).catch(err => { }).finally(() => {
                    this.modal.show = false;
                    this.modal.loading = false;
                });
            });
        },
        searchTable() {
            this.table.page.current = 1;
            this.initData();
        },
        resetSearchTable() {
            this.table.search = {
                name: null,
                date: [],
                type: []
            };
            this.searchTable();
        },
        handlePageChange(page) {
            this.table.page.current = page.current;
            this.table.page.pageSize = page.pageSize;
            this.initData();
        },
        initData() {
            this.table.loading = true;
            return IntegralLogService.listPage(
                this.id,
                this.table.search.name,
                this.table.search.date,
                this.table.search.type,
                this.table.page.current,
                this.table.page.pageSize
            ).then(res => {
                this.table.data = res.data.map(val => {
                    return val;
                });
                this.table.page.total = res.meta.pagination.total;
            }).catch(err => { }).finally(() => {
                this.table.loading = false;
            });
        },
    },
}
</script>
  
<style lang="less" scoped></style>